<template>
  <div class="news-wrapper uk-grid-small uk-child-width-1-2@s uk-child-width-1-3@m uk-child-width-1-4@l" data-uk-height-match="target: > div > a > .uk-card; row: false" data-uk-grid>
    <div class="news-item" v-for="item in items" v-bind:key="item.id">
      <a :href="item.url">
        <div v-if="item.image.length" class="uk-card news-image uk-flex uk-flex-center uk-flex-middle">
          <img :data-src="item.image" width="380" height="380" :alt="item.title" data-uk-img/>
        </div>
        <div v-else class="uk-card uk-card-body">
          <div class="title">{{ item.title }}</div>
          <div class="footer-content">
            <div class="type">{{ item.type }}</div>
            <div class="date">{{ item.date }}</div>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import qs from 'qs'

export default {
  data: () => {
    return {
      items: typeof window.items !== 'undefined' ? window.items : undefined,
      totalCount: typeof window.totalCount !== 'undefined' ? window.totalCount : undefined,
      type: typeof window.type !== 'undefined' ? window.type : undefined,
      page: 0,
      is_loading: false
    }
  },

  mounted () {
    var triggerHeight = 500;
    var $itemsView = $('.news-wrapper');
    var $window = $(window);
    var itemsViewTop = $itemsView.offset().top;

    $(window).scroll( () => {
      var itemsViewBottom = $itemsView.height() + itemsViewTop;
      var windowHeight = $window.height();
      var scrollBottom = $window.scrollTop() + windowHeight;

      if ( itemsViewBottom - scrollBottom < triggerHeight ) {

        if (!this.is_loading && this.totalCount > this.items.length) {
          this.page = this.page + 1;
          this.sendItemsRequest(this.page);
        }
      }
    });

  },

  methods: {

    appendItems (items) {
      this.items = this.items.concat(items)
    },

    sendItemsRequest (page) {
      this.is_loading = true

      let data = {
        page: page,
        type: this.type
      }
      axios.post('/newsajax',
        qs.stringify(data),
        {
          emulateJSON: true,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          }
        }
      ).then((response) => {
        this.is_loading = false
        this.appendItems(response.data.items)
        console.log(this.items)
      })

    }

  }
}



</script>
